import { render, staticRenderFns } from "./StudentIndividualWork.vue?vue&type=template&id=4204c31b"
import script from "./StudentIndividualWork.vue?vue&type=script&lang=js"
export * from "./StudentIndividualWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports